import { render, staticRenderFns } from "./InsuranceTab.vue?vue&type=template&id=f19caea8&scoped=true"
import script from "./InsuranceTab.vue?vue&type=script&lang=js"
export * from "./InsuranceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19caea8",
  null
  
)

export default component.exports